import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-669f944f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-image" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "image is-16by9" }
const _hoisted_5 = { alt: "Placeholder image" }
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = { class: "media" }
const _hoisted_8 = { class: "media-content" }
const _hoisted_9 = { class: "title is-6" }
const _hoisted_10 = { class: "subtitle is-6" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "description hide-overflown-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "date is-pulled-right" }

import { computed } from 'vue';

import { IVideo } from '@/types/YoutubeApi';

import { getChannelLink } from '@/util/youtube';
import { getReadableDate } from '@/util/date';

import AppBlacklistChannelSwitch from '@/components/AppBlacklistChannelSwitch.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  video: {
    // @ts-ignore
    type: IVideo,
    required: true,
  },
  token: {
    type: String,
    default: null,
  },
  permissions: {
    type: Array,
    default: null,
  },
},
  setup(__props) {

const props = __props



const showBlacklistChannelSwitch = computed(() => props.token && props.permissions.includes('create:ban'));


return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _unref(getChannelLink)(__props.video.channelId),
        target: "_blank"
      }, [
        _createElementVNode("figure", _hoisted_4, [
          _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
            [_directive_lazy, __props.video.thumbnailUrl]
          ])
        ])
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(__props.video.title), 1),
          _createElementVNode("p", _hoisted_10, "@" + _toDisplayString(__props.video.channelTitle), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(__props.video.description), 1),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(getReadableDate)(__props.video.publishedAt)), 1)
      ]),
      (_unref(showBlacklistChannelSwitch))
        ? (_openBlock(), _createBlock(AppBlacklistChannelSwitch, {
            key: 0,
            "channel-id": __props.video.channelId,
            token: __props.token
          }, null, 8, ["channel-id", "token"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})